import { h } from 'preact';

// TODO: better to add the non breaking space in php
export default function PlotPropertyFieldAlternative({ label, value }) {
	return (
		<tr>
			<td colspan="2">
				<strong>{label}</strong><br />
				{typeof value === 'string' ? value.replace(/(€)(\s)/g, '$1' + String.fromCharCode(160)) : value}
			</td>
		</tr>
	);
}
